import { BookOpenText, ShieldAlert, Stethoscope } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function About() {
  const { t } = useLang();
  return (
    <div className="max-w-2xl" data-testid="about-page">
      <div className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground mb-3 font-mono">
        <span className="title-rule" />{t("about.eyebrow")}
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight mb-6">
        {t("about.title1")} <em className="text-accent italic">{t("about.titleAccent")}</em>
      </h1>
      <p className="text-base text-muted-foreground leading-relaxed mb-10">
        {t("about.lead")}
      </p>

      <div className="space-y-5">
        <Item icon={Stethoscope} title={t("about.item1Title")} text={t("about.item1Text")} />
        <Item icon={BookOpenText} title={t("about.item2Title")} text={t("about.item2Text")} />
        <Item icon={ShieldAlert} title={t("about.item3Title")} text={t("about.item3Text")} />
      </div>

      <div className="mt-12 p-5 border border-dashed border-border rounded-md bg-card/50">
        <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground mb-1.5">{t("about.sourceLabel")}</div>
        <p className="text-sm">{t("about.sourceText")}</p>
      </div>
    </div>
  );
}

function Item({ icon: Icon, title, text }) {
  return (
    <div className="flex gap-4">
      <div className="size-10 rounded-md bg-secondary text-primary flex items-center justify-center shrink-0">
        <Icon className="size-5" />
      </div>
      <div>
        <h3 className="font-serif text-lg font-medium mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{text}</p>
      </div>
    </div>
  );
}
